/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CartItems from "./CartItems";
import { CartFooter } from "./CartFooter";
import "./cart.css";
import { useParams } from "react-router-dom";
import http from "../../../services/http";
import { getAPIURL, getVendorSettings } from "../../../services/helper";
import {
  orderToCart,
  payingCart,
} from "../../../ReduxToolkit/Reducers/CartReducer";
import { toast } from "react-toastify";
import Loader from "../../../Layout/Loader";
import CustomerModal from "./CustomerModal";

export const POSCart = () => {
  const dispatch = useDispatch();
  const { cartItems: reduxCartItems } = useSelector((state) => state.cart);
  const { vendorCustomers, paymentTypes } = useSelector((state) => state.app);
  const { order_id } = useParams();
  const [isWorking, setIsWorking] = useState(false);
  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const api_url = getAPIURL();

  // ✅ New local cart state (independent from Redux)
  const [localCartItems, setLocalCartItems] = useState([]);

  useEffect(() => {
    const loadOrderToCart = async () => {
      try {
        setIsWorking(true);
        const { data: order } = await http.get(`${api_url}/order/${order_id}`);
        dispatch(orderToCart(order.data));
        setIsWorking(false);
      } catch (error) {
        console.error("Failed to load order", error);
        setIsWorking(false);
        toast.error(error);
      }
    };

    if (order_id) loadOrderToCart();
  }, [order_id, dispatch, api_url]);

  const combinedCartItems = [...reduxCartItems, ...localCartItems];
  const isCartEmpty = combinedCartItems.length === 0;

  return (
    <div className="cart-section border-3" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {isWorking && <Loader />}

      <div className={`line-items-section ${isCartEmpty ? "no-items" : ""}`} style={{ flex: 1, overflowY: "auto" }}>
        {!isCartEmpty ? (
          <CartItems />
        ) : (
          <div>
            <h1 className="display-3 waving-cart">
              <i className="icofont icofont-social-opencart"></i>
            </h1>
          </div>
        )}
      </div>

      <CartFooter
        paymentTypes={paymentTypes}
        onCheckout={() => {
          const showCustomerPopup =
            getVendorSettings("customer_popup_checkout") === true;
          if (showCustomerPopup) {
            setCustomerModalOpen(true);
          } else {
            dispatch(payingCart());
          }
        }}
        style={{ flexShrink: 0 }}
      />

      <CustomerModal
        isOpen={customerModalOpen}
        toggle={() => setCustomerModalOpen(false)}
        onProceed={() => {
          dispatch(payingCart());
        }}
      />
    </div>
  );
};

export default POSCart;
